import { Pressable, View } from 'react-native'

import { styled } from '~/utils/styled'

export const Root = styled(Pressable, theme => {
  return {
    base: {
      gap: theme.spacingInlineTwopulse,
      backgroundColor: 'transparent',
      borderRadius: theme.borderRadiusPill,
    },
    variants: {},
  }
})

export const Actions = styled(View, theme => {
  return {
    base: {
      flexDirection: 'row',
      alignItems: 'center',
      borderRadius: theme.borderRadiusPill,
      backgroundColor: 'transparent',
    },
    variants: {
      size: {
        md: {
          paddingVertical: theme.paddingInsetTwopulse,
          paddingHorizontal: theme.paddingInsetTwopulse,
          gap: theme.spacingInlineOnepulse,
          minWidth: theme.sizingMedium,
          minHeight: theme.sizingMedium,
        },
        ml: {
          paddingVertical: theme.paddingInsetTwopulse,
          paddingHorizontal: theme.paddingInsetTwopulse,
          gap: theme.spacingInlineTwopulse,
          minWidth: theme.sizingMediumlarge,
          minHeight: theme.sizingMediumlarge,
        },
        lg: {
          paddingVertical: theme.paddingInsetTwopulse,
          paddingHorizontal: theme.paddingInsetTwopulse,
          gap: theme.spacingInlineTwopulse,
          minWidth: theme.sizingLarge,
          minHeight: theme.sizingLarge,
        },
        xl: {
          paddingVertical: theme.paddingInsetThreepulse,
          paddingHorizontal: theme.paddingInsetThreepulse,
          gap: theme.spacingInlineTwopulse,
          minWidth: theme.sizingExtralarge,
          minHeight: theme.sizingExtralarge,
        },
      },
      hasPressed: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryPressed,
          borderColor: theme.colorActionBorderNeutralTertiaryPressed,
          borderWidth: theme.borderWidthNone,
        },
      },
      hasError: {
        true: {
          borderWidth: theme.borderWidthHalfpulse,
          borderColor: theme.colorFormsBorderError,
        },
      },
      hasDisabled: {
        true: {
          backgroundColor: theme.colorActionFillNeutralTertiaryDisabled,
          borderColor: theme.colorActionBorderNeutralTertiaryDisabled,
          borderWidth: theme.borderWidthNone,
        },
      },
      hasReadOnly: {
        true: {
          //@TODO Alterar para o token colorActionFillNeutralTertiaryReadonly
          backgroundColor: '#00000000',
          //@TODO Alterar para o token colorActionBorderNeutralTertiaryReadonly
          borderColor: '#00000000',
          borderWidth: theme.borderWidthNone,
        },
      },
    },
    compoundVariants: [
      {
        variants: {
          size: 'xl',
          hasInternalLabel: true,
        },
        css: {
          paddingHorizontal: theme.paddingInsetSixpulse,
          paddingVertical: theme.paddingInsetThreepulse,
        },
      },
      {
        variants: {
          size: 'lg',
          hasInternalLabel: true,
        },
        css: {
          paddingHorizontal: theme.paddingInsetFivepulse,
          paddingVertical: theme.paddingInsetTwopulse,
        },
      },
      {
        variants: {
          size: 'ml',
          hasInternalLabel: true,
        },
        css: {
          paddingHorizontal: theme.paddingInsetFourpulse,
          paddingVertical: theme.paddingInsetTwopulse,
        },
      },
      {
        variants: {
          size: 'md',
          hasInternalLabel: true,
        },
        css: {
          paddingHorizontal: theme.paddingInsetFourpulse,
          paddingVertical: theme.paddingInsetOnepulse,
        },
      },
    ],
  }
})

export const NestedContainer = styled(View, () => {
  return {
    base: {},
    variants: {},
  }
})
